import { render, staticRenderFns } from "./SolidRingChat.vue?vue&type=template&id=5cac083a&scoped=true"
import script from "./SolidRingChat.vue?vue&type=script&lang=js"
export * from "./SolidRingChat.vue?vue&type=script&lang=js"
import style0 from "./SolidRingChat.vue?vue&type=style&index=0&id=5cac083a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac083a",
  null
  
)

export default component.exports